import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { InfracaoTransporte } from '@tivic-team/manager-ts/dist/mob';
import { InfracaoTransporteSearch } from 'app/services/mob/infracao-transporte.search';
import { InfracaoTransporteService } from 'app/services/mob/infracao-transporte.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'autocomplete-infracao',
  templateUrl: './autocomplete-infracao.component.html',
  styleUrls: ['./autocomplete-infracao.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutocompleteInfracaoComponent implements OnInit {

  formGroup: FormGroup;
  infracoesFiltrados: InfracaoTransporte[];

  constructor(
    private _infracaoTransporteService: InfracaoTransporteService,
    private _controlContainer: ControlContainer
  ) { }

  async ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.addControl('infracao', new FormControl());
    this.formGroup.get('infracao').valueChanges
      .pipe(
        switchMap(value => {
          if (value && typeof (value) === "string" && value.length > 2) {
            return this._infracaoTransporteService.findInfracoes(new InfracaoTransporteSearch({ nrInfracao: value }));
          }
          else {
            return of(null);
          }
        })
      )
      .subscribe(
        infracoes => this.infracoesFiltrados = infracoes
      );
  }

  async ngAfterViewInit() {
    this.formGroup.get('cdInfracao').valueChanges
      .pipe(
        switchMap(async (cdInfracao) => {
          if (cdInfracao > 0) {
            let infracao: any = await this._infracaoTransporteService.get(cdInfracao);
            if (infracao == null)
              console.log('Infração indicada no AIT não existe no banco ou houve um erro ao buscá-la.');
            else {
              this.formGroup.get('infracao').setValue(infracao);
              this.formGroup.get('dsInfracao').setValue(infracao.dsInfracao);
              this.formGroup.get('nrValorUfir').setValue(infracao.nrValorUfir);
            }
          }
          return of(null);
        })
      )
      .subscribe();
  }

  displayFn(infracao: any) {
    if (infracao) {
      return infracao.nrInfracao;
    }
  }

  async infracaoSelecionado($event) {
    let infracao = $event.option.value;
    this.selecionarInfracao(infracao.cdInfracao);
  }

  selecionarInfracao(cdInfracao: InfracaoTransporte) {
    this.formGroup.get("cdInfracao").setValue(cdInfracao)
  }
}
